export default __webpack_public_path__ + "static/media/anniversary_Hk.bb223671.jpg";